// extracted by mini-css-extract-plugin
export default {"tutorials":"SubHeader_tutorials__rhgqR"};